// نمایشِ اطلاعاتِ آگهی (جست‌وجو، صفحه‌ی آگهی) — یک جا، تا همه‌جا یک‌جور باشد
export const fa = (n, d = 0) => Number(n || 0).toLocaleString('fa-IR', { maximumFractionDigits: d });

export const DEAL_LABELS = { sale: 'فروش', rent: 'رهن و اجاره' };
export const PROPERTY_LABELS = { apartment: 'آپارتمان', villa: 'ویلایی', land: 'زمین', office: 'اداری', shop: 'مغازه' };
export const ORIENTATION_LABELS = { north: 'شمالی', south: 'جنوبی', east: 'شرقی', west: 'غربی' };
export const AMENITY_LABELS = { elevator: 'آسانسور', parking: 'پارکینگ', storage: 'انباری', balcony: 'بالکن' };

// تعدادِ بازدید، کوتاه: ۸۵۰ / ۱٫۲ هزار / ۳ میلیون
export function shortViews(n) {
  const v = Math.max(0, Number(n) || 0);
  if (v < 1000) return fa(v);
  if (v < 1e6) return `${fa(v / 1000, v < 1e4 ? 1 : 0)} هزار`;
  return `${fa(v / 1e6, 1)} میلیون`;
}

// «۴ میلیارد و ۲۰۰ میلیون» — کوتاه برای کارت‌ها
export function shortToman(n) {
  const v = Number(n) || 0;
  if (!v) return '';
  if (v >= 1e9) {
    const b = Math.floor(v / 1e9);
    const m = Math.round((v % 1e9) / 1e6);
    return m ? `${fa(b)} میلیارد و ${fa(m)} میلیون` : `${fa(b)} میلیارد`;
  }
  if (v >= 1e6) return `${fa(Math.round(v / 1e6))} میلیون`;
  return fa(v);
}

export function priceLine(l) {
  if (!l) return '';
  if (l.dealType === 'rent') {
    const parts = [];
    if (l.deposit) parts.push(`ودیعه ${shortToman(l.deposit)}`);
    if (l.rent) parts.push(`اجاره ${shortToman(l.rent)}`);
    if (l.deposit && !l.rent) return `رهن کامل ${shortToman(l.deposit)} تومان`;
    return parts.length ? `${parts.join(' · ')} تومان` : 'توافقی';
  }
  return l.price ? `${shortToman(l.price)} تومان` : 'توافقی';
}

export function timeAgo(iso) {
  if (!iso) return '';
  const date = new Date(iso);
  const min = Math.floor((Date.now() - date.getTime()) / 60000);
  if (min < 1) return 'لحظاتی پیش';
  if (min < 60) return `${fa(min)} دقیقه پیش`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${fa(h)} ساعت پیش`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'دیروز';
  if (d < 7) return `${fa(d)} روز پیش`;
  if (d < 30) return `${fa(Math.floor(d / 7))} هفته پیش`;
  return date.toLocaleDateString('fa-IR', { day: 'numeric', month: 'long' });
}

export function listingTitle(d) {
  const l = d.listing || {};
  if (l.title) return l.title;
  const kind = [DEAL_LABELS[l.dealType], PROPERTY_LABELS[l.propertyType]].filter(Boolean).join(' ');
  return [kind, l.area && `${fa(l.area)} متری`].filter(Boolean).join(' ') || 'آگهی';
}

// سالِ ساخت (اگر فرم داده) یا سنِ بنا
export function buildText(l) {
  if (!l) return '';
  const year = l.extra && l.extra.constructionYear;
  if (year) return String(year).replace(/\d/g, (c) => '۰۱۲۳۴۵۶۷۸۹'[c]);
  if (l.buildYear === 0) return 'نوساز';
  return l.buildYear ? `${fa(l.buildYear)} سال` : '';
}
